import React from "react";
import style from "./style.module.css";

const Page404 = () => {

    return (
        <div className={style.rootDiv}>
          <h1>404 PAGE NOT FOUND</h1>
          <p>😔</p>
        </div>
    );
};

export default Page404;